"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function get() {
    return _Table["default"];
  }
});
Object.defineProperty(exports, "Tbody", {
  enumerable: true,
  get: function get() {
    return _Tbody["default"];
  }
});
Object.defineProperty(exports, "Td", {
  enumerable: true,
  get: function get() {
    return _Td["default"];
  }
});
Object.defineProperty(exports, "Th", {
  enumerable: true,
  get: function get() {
    return _Th["default"];
  }
});
Object.defineProperty(exports, "Thead", {
  enumerable: true,
  get: function get() {
    return _Thead["default"];
  }
});
Object.defineProperty(exports, "Tr", {
  enumerable: true,
  get: function get() {
    return _Tr["default"];
  }
});
var _Table = _interopRequireDefault(require("./components/Table"));
var _Tbody = _interopRequireDefault(require("./components/Tbody"));
var _Td = _interopRequireDefault(require("./components/Td"));
var _Th = _interopRequireDefault(require("./components/Th"));
var _Thead = _interopRequireDefault(require("./components/Thead"));
var _Tr = _interopRequireDefault(require("./components/Tr"));